import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'

import { CardFooter } from '../../components/layout/Card'
import { BudgetContext } from './context'
import { Button } from '../../components/Button'
import { ActionablesContext } from '../../contexts/ActionablesContext'

export const Footer = () => {
  const { readOnly, frozen } = useContext(ActionablesContext)

  if (frozen) return null

  return (
    <CardFooter className='!justify-center sm:!justify-end'>
      { readOnly
        ? <ReadOnlyBudgetFooter />
        : <BudgetFooter />
      }
    </CardFooter>
  )
}

const ReadOnlyBudgetFooter = () => {
  const { state: { onCreateNewScenario } } = useContext(BudgetContext)

  return (
    <Box
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      className='budget__read-only-footer flex-col sm:flex-row'
    >
      <p>You can edit your budget in scenario planning</p>
      <Button primary onClick={() => onCreateNewScenario()} trackAs='Read only budget: New scenario'>Create a new scenario</Button>
    </Box>
  )
}

const BudgetFooter = () => {
  const { state: { selectedTab, loading } } = useContext(BudgetContext)
  return (
    <Box
      className='budget__footer'
    >
      { selectedTab === 0
        ? <Button primary type='submit' disabled={loading}>{loading ? 'Updating simple budget...' : 'Update and use simple expenses'}</Button>
        : <Button primary type='submit' disabled={loading}>{loading ? 'Updating detailed budget...' : 'Update and use detailed expenses'}</Button>
      }
    </Box>
  )
}
